import React, { Component } from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom';
import _ from 'lodash'
import ActionsRow from './ActionsRow'

class Table extends Component {
    renderRows(){
        if(_.isEmpty(this.props.clients)){
            return(<div>loading</div>)
        }

        return this.props.clients.map((client) => {
            let rowClassName = Number(client.approved) === 0 ? "alert-success" : ""
            let totalPendientes = _.filter(client.casos, function(c) { return c.status == 2; })
            let totalEnviado = _.filter(client.casos, function(c) { return c.status == 0; })
            return (
                <tr key={client.id} className={rowClassName}>
                    <td>
                        <Link className="panel-block" to={"/admin/clients/" + client.id}>
                            <i className="fa fa-user-o"></i> <b>{client.name}</b>
                        </Link>
                    </td>
                    <td className="text-muted">
                        {moment(client.created_at).local().format('DD-MM-YYYY') }
                    </td>
                    <td className="text-muted"
                        style={{textAlign: "right"}}>
                        <b className="status-text-1">{client.pendientes}</b>
                    </td>
                    <td className="text-muted"
                        style={{textAlign: "right"}}>
                        <b className="status-text-2">{client.enviados}</b>
                    </td>
                    <td className="text-muted"
                        style={{textAlign: "right"}}>
                        <b>{client.casos}</b>
                    </td>
                    <td className="text-muted"
                        style={{textAlign: "right"}}>
                        <ActionsRow
                            approved={client.approved}
                            clientId={client.id}
                            actionApprove={this.props.approveClient}
                            actionDelete={this.props.deleteClient}
                        />
                    </td>
                </tr>
            );
        })
    }
    render(){
        if(!_.isEmpty(this.props.clients)){
            return(
                <table className="table table-hover">
                    <thead>
                    <tr>
                        <th
                            scope="col"
                            className={this.props.sort === "name" ? "th-order active" : "th-order" }
                            onClick={()=>{
                                let order = this.props.order === "asc" ? "desc" : "asc"
                                this.props.applyOrder("name", order)
                            }}
                        >Cliente <i className="fa fa-sort fa-1"></i></th>
                        <th
                            scope="col"
                            className={this.props.sort === "created_at" ? "th-order active" : "th-order" }
                            style={{width:"15%"}}
                            onClick={()=>{
                                let order = this.props.order === "asc" ? "desc" : "asc"
                                this.props.applyOrder("created_at", order)

                            }}
                        >Fecha de alta <i className="fa fa-sort fa-1"></i></th>
                        <th
                            scope="col"
                            className={this.props.sort === "name" ? "th-order active" : "th-order" }
                            style={{textAlign: "right"}}
                            onClick={()=>{
                                let order = this.props.order === "asc" ? "desc" : "asc"
                                this.props.applyOrder("pendientes", order)
                            }}
                        >Casos pendientes <i className="fa fa-sort fa-1"></i></th>
                        <th
                            scope="col"
                            className={this.props.sort === "name" ? "th-order active" : "th-order" }
                            style={{textAlign: "right"}}
                            onClick={()=>{
                                let order = this.props.order === "asc" ? "desc" : "asc"
                                this.props.applyOrder("enviados", order)
                            }}
                        >Casos enviados <i className="fa fa-sort fa-1"></i></th>
                        <th
                            scope="col"
                            className={this.props.sort === "name" ? "th-order active" : "th-order" }
                            style={{textAlign: "right"}}
                            onClick={()=>{
                                let order = this.props.order === "asc" ? "desc" : "asc"
                                this.props.applyOrder("casos", order)
                            }}
                        >Casos totales <i className="fa fa-sort fa-1"></i></th>
                        <th
                            scope="col"
                        >&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.renderRows()}
                    </tbody>
                </table>
            )
        }else{
            return(
                <div className="alert alert-secondary" role="alert">
                    No existen clientes con los criterios de búsqueda seleccionados
                </div>
            )
        }

    }
}
export default Table


// WEBPACK FOOTER //
// ./resources/assets/js/components/admin/clients/Table.jsx